export const MEDIA_ASSET_CHANNELS = [
  "youtube",
  "google-display",
  "ebay-kleinanzeigen",
  "facebook",
  "instagram",
  "linkedin-feed",
  "reddit",
  "pinterest",
  "snapchat",
  "spotify",
  "twitter"
];

export const VERTICAL_MEDIA_ASSET_CHANNELS = [
  "youtube",
  "google-search",
  "google-display",
  "ebay-kleinanzeigen",
  "facebook",
  "instagram",
  "linkedin-feed",
  "pinterest",
  "snapchat",
  "spotify",
  "twitter"
];

export const VERTICAL_TEMPLATES = [
  "WaveImage",
  "OneToneImage",
  "DefaultImage",
  "VerticalImage",
  "ShapeImage",
  "VerticalVideo",
  "RawVideovertical"
];
